var jade = require("/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<header class=\"page-title\"><h1>{{:: vm.i18n.gettext(\"Anonymisierungsaufträge ansehen\") }}</h1></header><section class=\"main col-lg-12\"><dias-table config=\"vm.anonTable\" table-name=\"'anonymisierungsauftraege'\"></dias-table></section>");;return buf.join("");
}